import { GUI } from 'dat.gui'
import { BlendFunction, BloomEffect, EffectPass, SelectiveBloomEffect } from 'postprocessing'

import { Bloom } from '../../../../../trillion-common/src/objects/posteffects/bloom.object'
import { BloomDto } from '../../../../../trillion-common/src/dto/posteffects/bloom.dto'
import { BloomRadius } from '../posteffects'
import { StoreScheme } from '../../../shared/store/store'

export function addBloomGUI(
  gui: GUI,
  type: string,
  bloomEffect: BloomEffect | SelectiveBloomEffect,
  bloomPass: EffectPass,
  bloomConfig: BloomDto | undefined,
  store: StoreScheme,
) {
  const setBloom = store.getState().setBloom
  const setBloomSelective = store.getState().setBloomSelective

  const bloomOptions = {
    intensity: bloomEffect.intensity,
    radius: (bloomEffect as BloomRadius).mipmapBlurPass.radius,

    luminanceFilter: bloomConfig?.luminanceFilter ?? bloomEffect.luminancePass.enabled,
    luminanceThreshold: bloomEffect.luminanceMaterial.threshold,
    luminanceSmoothing: bloomEffect.luminanceMaterial.smoothing,

    opacity: bloomConfig?.opacity ?? (bloomEffect.blendMode.opacity.value as number),
    blendFunction: bloomConfig?.blendFunction ?? bloomEffect.blendMode.blendFunction,
    dithering: bloomConfig?.dithering ?? bloomPass.dithering,
  }

  const bloomFolder = gui.addFolder(`Bloom ${type}`)
  bloomFolder.open()

  bloomFolder.add(bloomOptions, 'intensity', 0.0, 10.0, 0.01).onChange((value: number) => {
    bloomEffect.intensity = value
    updateBloomEffect((bloom) => {
      bloom.intensity = value
    })
  })
  bloomFolder.add(bloomOptions, 'radius', 0.0, 1.0, 0.001).onChange((value: number) => {
    ;(bloomEffect as BloomRadius).mipmapBlurPass.radius = value
    updateBloomEffect((bloom) => {
      bloom.radius = value
    })
  })

  bloomFolder
    .add(bloomOptions, 'luminanceFilter')
    .name('filter')
    .onChange((value: boolean) => {
      bloomEffect.luminancePass.enabled = value
      updateBloomEffect((bloom) => {
        bloom.luminanceFilter = value
      })
    })
  bloomFolder
    .add(bloomOptions, 'luminanceThreshold', 0.0, 1.0, 0.001)
    .name('threshold')
    .onChange((value: number) => {
      bloomEffect.luminanceMaterial.threshold = value
      updateBloomEffect((bloom) => {
        bloom.luminanceThreshold = value
      })
    })
  bloomFolder
    .add(bloomOptions, 'luminanceSmoothing', 0.0, 1.0, 0.001)
    .name('smoothing')
    .onChange((value: number) => {
      bloomEffect.luminanceMaterial.smoothing = value
      updateBloomEffect((bloom) => {
        bloom.luminanceSmoothing = value
      })
    })

  bloomFolder.add(bloomOptions, 'opacity', 0.0, 1.0, 0.01).onChange((value: number) => {
    bloomEffect.blendMode.opacity.value = value
  })
  bloomFolder
    .add(bloomOptions, 'blendFunction', BlendFunction)
    .name('blend mode')
    .onChange((value) => {
      const numValue = Number(value)
      bloomEffect.blendMode.blendFunction = numValue
      updateBloomEffect((bloom) => {
        bloom.blendFunction = numValue
      })
    })
  bloomFolder.add(bloomOptions, 'dithering').onChange((value: boolean) => {
    bloomPass.dithering = value
    updateBloomEffect((bloom) => {
      bloom.dithering = value
    })
  })

  function setBloomOptions() {
    if (type === 'general') {
      setBloom(bloomOptions)
    }

    if (type === 'diamonds') {
      setBloomSelective(bloomOptions)
    }
  }

  function updateBloomEffect(updateCallback: (bloom: Bloom) => void) {
    updateCallback(bloomOptions)
    setBloomOptions()
  }

  setBloomOptions()
}
